import { motion } from "framer-motion";

function SkillCard({ icon, delay, textOne, textTwo }) {
  return (
    <motion.div
      className="flex w-full"
      exit={{ scale: 1 }}
      initial={{ scale: 0 }}
      animate={{ scale: 1 }}
      transition={{ duration: 0.3, delay }}
    >
      <div className="flex flex-col justify-center w-full custom-card p-1 mb-5 md:mb-0">
        <div className="flex flex-col items-center w-full md:flex-row p-3">
          <div className="mx-auto my-2 md:my-0">{icon}</div>
          <div className="flex flex-col flex-grow text-center md:text-left px-2">
            <p className="text-white font-[poppins] font-bold">{textOne}</p>
            <p className="font-[poppins] text-gray-300">{textTwo}</p>
          </div>
        </div>
      </div>
    </motion.div>
  );
}

export default SkillCard;
